import { BulbIcon } from 'foundations-assets/icons/components/BulbIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const MemorySourceIcon = ({
  borderWidth = '100'
}) => /*#__PURE__*/_jsx(Flex, {
  borderRadius: "full",
  blockSize: "20px",
  inlineSize: "20px",
  padding: "100",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "fill-surface-default",
  borderWidth: borderWidth,
  borderStyle: "solid",
  borderColor: "border-core-default",
  children: /*#__PURE__*/_jsx(BulbIcon, {
    color: "icon-core-default",
    size: "200"
  })
});
export default MemorySourceIcon;